function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { UpOne } from '../../common/icons';
import { useColorFields } from '../../hooks/color';
import { Dropdown } from '../dropdown';
import { InputNumber } from '../input-number';
var Menu = Dropdown.Menu,
    MenuItem = Dropdown.MenuItem;

function FieldItem(props) {
  var value = props.value,
      _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      max = props.max,
      onValueChange = props.onValueChange,
      disabled = props.disabled;
  var cls = usePrefixCls('color-field-item');
  return React.createElement("div", {
    className: cls
  }, React.createElement(InputNumber, {
    disabled: disabled,
    size: "xs",
    value: value,
    min: min,
    max: max,
    strict: true,
    onValueChange: onValueChange
  }));
}

export function ColorFields(props) {
  var _props$defaultType = props.defaultType,
      defaultType = _props$defaultType === void 0 ? 'rgb' : _props$defaultType,
      _props$hasAlpha = props.hasAlpha,
      hasAlpha = _props$hasAlpha === void 0 ? false : _props$hasAlpha;

  var _useState = useState(defaultType),
      _useState2 = _slicedToArray(_useState, 2),
      type = _useState2[0],
      setType = _useState2[1];

  var _useColorFields = useColorFields(),
      _useColorFields2 = _slicedToArray(_useColorFields, 2),
      fields = _useColorFields2[0],
      _useColorFields2$ = _useColorFields2[1],
      onHueChange = _useColorFields2$.onHueChange,
      onSaturationChange = _useColorFields2$.onSaturationChange,
      onLightChange = _useColorFields2$.onLightChange,
      onRedChange = _useColorFields2$.onRedChange,
      onGreenChange = _useColorFields2$.onGreenChange,
      onBlueChange = _useColorFields2$.onBlueChange,
      onAlphaChange = _useColorFields2$.onAlphaChange;

  var r = fields.r,
      g = fields.g,
      b = fields.b,
      h = fields.h,
      s = fields.s,
      l = fields.l,
      a = fields.a;
  var cls = usePrefixCls('color-fields');
  var leftCls = usePrefixCls('color-fields-left');
  var leftInputCls = usePrefixCls('color-fields-left-input');
  var leftSwitchCls = usePrefixCls('color-fields-left-switch');
  var rightCls = usePrefixCls('color-fields-right');
  var menu = React.createElement(Menu, {
    onClick: function onClick(id) {
      return setType(id);
    }
  }, React.createElement(MenuItem, {
    id: "rgb"
  }, "RGB"), React.createElement(MenuItem, {
    id: "hsl"
  }, "HSL"));
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: leftCls
  }, type === 'rgb' && React.createElement("div", {
    className: leftInputCls
  }, React.createElement(FieldItem, {
    value: r,
    max: 255,
    onValueChange: onRedChange
  }), React.createElement(FieldItem, {
    value: g,
    max: 255,
    onValueChange: onGreenChange
  }), React.createElement(FieldItem, {
    value: b,
    max: 255,
    onValueChange: onBlueChange
  })), type === 'hsl' && React.createElement("div", {
    className: leftInputCls
  }, React.createElement(FieldItem, {
    value: h,
    max: 360,
    onValueChange: onHueChange
  }), React.createElement(FieldItem, {
    value: s,
    max: 100,
    onValueChange: onSaturationChange
  }), React.createElement(FieldItem, {
    value: l,
    max: 100,
    onValueChange: onLightChange
  })), React.createElement(Dropdown, {
    menu: menu
  }, React.createElement("div", {
    className: leftSwitchCls
  }, React.createElement("div", null, type.charAt(0).toUpperCase()), React.createElement("div", null, type.charAt(1).toUpperCase()), React.createElement("div", null, type.charAt(2).toUpperCase()), React.createElement(UpOne, {
    size: 8,
    theme: "filled"
  })))), React.createElement("div", {
    className: rightCls
  }, React.createElement(FieldItem, {
    disabled: !hasAlpha,
    value: a,
    max: 100,
    onValueChange: onAlphaChange
  }), React.createElement("div", null, "A")));
}